import $ from '@modules/jquery-import';

/**
 * Toggle a hidden from a dynamically generated trigger element
 */
$.fn.QuickView = function ( opt ) {
    var defaults = {
            trigger_template: '<span class="quick-view-action"></span>',
            trigger_class: 'link1',
            label: 'Quick View',
            auto_hide: true,
            remove_trigger: false,
        },
        opt = $.extend( defaults, opt );

    var collection = $( this ),
        parent = collection.parent(),
        elm_trigger = $( opt.trigger_template )
            .addClass( opt.trigger_class )
            .html( opt.label );

    // ad trigger to DOM
    elm_trigger.appendTo( parent );
    collection.remove();

    // bind events
    elm_trigger.on( 'click', show );

    function show() {
        if ( opt.remove_trigger ) {
            elm_trigger.remove()
        }
        $( collection ).appendTo( parent );
        collection.addClass( 'slide-up' );
    }

    return this;
};
